import { FC } from 'react';
import { TimePicker as SfTimePicker } from '@silverfort/sf-components';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';

interface TimePickerProps {
    value?: Date;
    onChange: (date?: Date) => void;
    className?: string;
    [key: string]: unknown; // Allow additional props like slotProps
}

const TimePicker: FC<TimePickerProps> = ({ value, onChange, className, ...props }) => {
    const sfDatePickerValue = value ? moment(value) : null;
    const isToday = value ? moment(value).isSame(moment(), 'day') : false;

    const handleChange = (date: moment.Moment | null) => {
        onChange(date?.toDate());
    };

    // todo: remove LocalizationProvider and @mui/x-date-pickers from package.json after - https://silverfort.atlassian.net/browse/AF-36664
    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <SfTimePicker
                className={className}
                disablePast={isToday}
                value={sfDatePickerValue}
                onChange={handleChange}
                onAccept={handleChange}
                {...props}
            />
        </LocalizationProvider>
    );
};

export default TimePicker;
